var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_725_3724",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_725_3724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 8.30774V5.30774H8.00007V8.30774H6.50007V3.80774H17.5001V8.30774H16.0001ZM17.8078 12.3077C18.0912 12.3077 18.3287 12.2119 18.5203 12.0202C18.712 11.8286 18.8078 11.5911 18.8078 11.3077C18.8078 11.0244 18.712 10.7869 18.5203 10.5952C18.3287 10.4036 18.0912 10.3077 17.8078 10.3077C17.5245 10.3077 17.287 10.4036 17.0953 10.5952C16.9037 10.7869 16.8078 11.0244 16.8078 11.3077C16.8078 11.5911 16.9037 11.8286 17.0953 12.0202C17.287 12.2119 17.5245 12.3077 17.8078 12.3077ZM16.0001 19V14.7307H8.00007V19H16.0001ZM17.5001 20.5H6.50007V16.5H2.78857V10.8077C2.78857 10.0994 3.03057 9.50566 3.51457 9.02649C3.99857 8.54732 4.58991 8.30774 5.28857 8.30774H18.7116C19.4199 8.30774 20.0137 8.54732 20.4928 9.02649C20.972 9.50566 21.2116 10.0994 21.2116 10.8077V16.5H17.5001V20.5ZM19.7116 15V10.8077C19.7116 10.5244 19.6157 10.2869 19.4241 10.0952C19.2324 9.90357 18.9949 9.80774 18.7116 9.80774H5.28857C5.00524 9.80774 4.76774 9.90357 4.57607 10.0952C4.38441 10.2869 4.28857 10.5244 4.28857 10.8077V15H6.50007V13.2307H17.5001V15H19.7116Z",
    fill: "#3D4259"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.2fe709808904bd086868b5c3201f5dd2.svg";
export { ForwardRef as ReactComponent };